import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconSubaccounts = (props: SvgProps) => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props.title}</title>
    <path
      d="M17.3346 13.4449C17.3346 14.7332 16.2903 15.7776 15.002 15.7776C13.7136 15.7776 12.6693 14.7332 12.6693 13.4449C12.6693 12.1566 13.7136 11.1122 15.002 11.1122C16.2903 11.1122 17.3346 12.1566 17.3346 13.4449Z"
      fill="#142D63"
    />
    <path
      d="M15.002 18.1102C13.0579 18.1102 11.2329 18.6198 9.65314 19.5128C10.9368 21.0327 12.8567 21.998 15.002 21.998C17.1472 21.998 19.0671 21.0327 20.3508 19.5128C18.7711 18.6198 16.946 18.1102 15.002 18.1102Z"
      fill="#142D63"
    />
    <path
      d="M15.002 21.998C18.8669 21.998 22 18.8649 22 15C22 11.1351 18.8669 8.00195 15.002 8.00195C11.137 8.00195 8.00391 11.1351 8.00391 15C8.00391 18.8649 11.137 21.998 15.002 21.998ZM15.002 21.998C12.8567 21.998 10.9368 21.0327 9.65314 19.5128C11.2329 18.6198 13.0579 18.1102 15.002 18.1102C16.946 18.1102 18.7711 18.6198 20.3508 19.5128C19.0671 21.0327 17.1472 21.998 15.002 21.998ZM17.3346 13.4449C17.3346 14.7332 16.2903 15.7776 15.002 15.7776C13.7136 15.7776 12.6693 14.7332 12.6693 13.4449C12.6693 12.1566 13.7136 11.1122 15.002 11.1122C16.2903 11.1122 17.3346 12.1566 17.3346 13.4449Z"
      stroke="#142D63"
      stroke-width="1.91005"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="24.5" cy="5.5" r="3.5" fill="#142D63" />
    <circle cx="24.5" cy="24.5" r="3.5" fill="#142D63" />
    <circle cx="5.5" cy="24.5" r="3.5" fill="#142D63" />
    <circle cx="5.5" cy="5.5" r="3.5" fill="#142D63" />
    <path
      d="M7 7.5L9.5 10"
      stroke="#142D63"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M23.5 23L21 20.5"
      stroke="#142D63"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M23.5 7.5L21 10"
      stroke="#142D63"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7 23L9.5 20.5"
      stroke="#142D63"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
)
